module.exports = __webpack_public_path__ + "img/map-circle5.b62cc870.svg";